import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import '../../../styles/dataExports/SettingForm.css';

const getUnselectedFields = (selectedColumnObjs, fields) => {
    if (!selectedColumnObjs || !fields) {
        return [];
    }
    return fields.filter(field => !selectedColumnObjs.some(obj => obj.field === field));
}

const FieldEditor = ({ tablePoppedUp, selectedColumnObjs, setSelectedColumnObjs }) => {
    const table = tablePoppedUp;
    // console.log("table : ", table);
    const fields = table.columns.map(c => c.field).flat();
    const [selectedField, setSelectedField] = useState('');
    const [unselectedFields, setUnselectedFields] = useState(getUnselectedFields(selectedColumnObjs, fields));

    // console.log("selectedColumnObjs : ", selectedColumnObjs);


    const handleAddColumn = () => {

        if (selectedField !== '') {

            const field_exists = selectedColumnObjs.some(obj => obj.field === selectedField);

            if (!field_exists) { // Corrected the logic to check if the object doesn't exist
                let newSelectedColumnObjs = [...selectedColumnObjs, { field: selectedField, columnName: selectedField }];
                setSelectedColumnObjs(newSelectedColumnObjs);
                setUnselectedFields(getUnselectedFields(newSelectedColumnObjs, fields));
                toast.success(`Column ${selectedField} added successfully`, { duration: 2000 });

            } else {
                toast.error("Column already exists", { duration: 2000 });
            }

        } else {
            // console.log("Selected field or column name is empty.");
        }
        setSelectedField('');
    };

    const handleRemoveColumn = (index) => {
        const updatedColumns = [...selectedColumnObjs];
        updatedColumns.splice(index, 1);
        setSelectedColumnObjs(updatedColumns);
        setUnselectedFields(getUnselectedFields(updatedColumns, fields));
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <div>
                {/* <ColoredScrollbars style={{ height: "165px", width: "400px" }}> */}
                    {selectedColumnObjs && selectedColumnObjs.length === 0
                        ? <p style={{ textAlign: "center" }}>No columns selected</p>
                        : (<table style={{ width: "400px", textAlign: "center", color: "white" }}>
                            <thead style={{ fontSize: "smaller" }}>
                                <tr>
                                    <th style={{ flex: 1 }}>Existing Field</th>
                                    <th style={{ flex: 1 }}>Name As</th>
                                    <th style={{ flex: 1 }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedColumnObjs && selectedColumnObjs.map((column, index) => (
                                    <tr key={index}>
                                        <td>{column.field}</td>
                                        <td>
                                            <input
                                                type="text"
                                                value={column.columnName}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    
                                                    // Allow only letters, numbers, and underscores
                                                    const regex = /^[a-zA-Z0-9_]*$/; 
                                                    
                                                    if (regex.test(inputValue)) {
                                                    let temp = [...selectedColumnObjs];
                                                    temp[index].columnName = inputValue;
                                                    setSelectedColumnObjs(temp);
                                                    } else {
                                                    toast.error("Invalid input! Only letters, numbers, and underscores are allowed.");
                                                    }
                                                }} 
                                            />
                                            {
                                                column.columnName.trim() === "" && <PriorityHighIcon sx={{color:"yellow"}}/>
                                            }
                                        </td>
                                        <td style={{display:"flex", justifyContent:"center"}}>
                                            <div className="icon-container" onClick={() => handleRemoveColumn(index)}>
                                                <DeleteOutlineIcon/>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>)}
                {/* </ColoredScrollbars> */}
            </div>
            {
                selectedColumnObjs && selectedColumnObjs.length < fields.length && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <select
                            className="setting-form-dark-select"
                            value={selectedField} onChange={(e) => setSelectedField(e.target.value)}
                            >
                            <option value="">Add more columns</option>
                            {unselectedFields.map((obj, index) => (
                                <option key={index} value={obj.field}>{obj}</option>
                            ))}
                        </select>
                        {selectedField && (
                            <div style={{ display: "flex" }}>
                                <button 
                                    style={{ all: "unset", cursor: "pointer" }} 
                                    onClick={handleAddColumn}
                                >
                                    Add
                                </button>
                            </div>
                        )}
                    </div>
                )
            }
        </div>
    );
};

export default FieldEditor;